function zen2han(target) {
  return target
    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
    .replace(/[‐－―−]/g, '-')
    .replace('　', ' ');
}

export default zen2han;
